module.exports = __webpack_public_path__ + "img/camera.e6b88bea.svg";